'use client'
import { Box } from '@mui/material'
import Script from 'next/script'
import { useEffect, useState } from 'react'

type Props = {}

export const ZaloButton = (props: Props) => {
  const [isLoad, setIsLoad] = useState(false)

  useEffect(() => {
    // Kiểm tra nếu là Lighthouse hoặc Headless Chrome thì không load Zalo
    const isLighthouse =
      typeof window !== 'undefined' &&
      (navigator.userAgent.includes('Chrome-Lighthouse') ||
        navigator.userAgent.includes('Lighthouse') ||
        /headless/i.test(navigator.userAgent))

    if (isLighthouse) {
      return
    }

    const handleInteraction = () => {
      setIsLoad(true)
      removeListeners()
    }

    const removeListeners = () => {
      window.removeEventListener('scroll', handleInteraction)
      window.removeEventListener('touchstart', handleInteraction)
      window.removeEventListener('click', handleInteraction)
    }

    window.addEventListener('scroll', handleInteraction, { passive: true })
    window.addEventListener('touchstart', handleInteraction, { passive: true })
    window.addEventListener('click', handleInteraction, { passive: true })

    return () => {
      removeListeners()
    }
  }, [])

  if (!isLoad) return null

  return (
    <Box>
      <Script src="https://sp.zalo.me/plugins/sdk.js" strategy="lazyOnload"></Script>
      <Box
        sx={{
          position: 'fixed',
          bottom: '1.5rem !important',
          left: '0.8rem !important',
          zIndex: 100,
          borderRadius: '100%',
        }}
        className="zalo-chat-widget custom-button-zalo"
        data-oaid="2365065712824147986"
        data-welcome-message="Hydra Shop xin chào. rất vui khi được hỗ trợ bạn!"
        data-autopopup="0"
      ></Box>
    </Box>
  )
}

